import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';
import { Opportunity } from '@wdx/clmi/clmi-swagger-gen';

@Injectable({ providedIn: 'root' })
export class EventIdOpportunitiesApiService extends BaseApiService {
    // TODO: delete this file and use the generated version when this BE bug is fixed: https://wealthdynamixltd.atlassian.net/browse/CLMI-11509
    get(id: string, options = {}): Observable<Opportunity[]> {
        return this._get<Opportunity[]>(`/Event/${id}/opportunities`, options);
    }
}
